// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__8Ta1k","loader":"styles_loader__2nhEg","username":"styles_username__2PT8c","entity":"styles_entity__e6SiJ"};